import { http } from '../services';

class ApiService {
    getBairros(texto) {
        return http.get('/api/bairros', { texto });
    }

    getCidades(texto) {
        return http.get('/api/cidades', { texto });
    }

    getFormasDePagamento(codigoProjeto) {
        return http.get(`/api/formas-de-pagamento/${codigoProjeto}`);
    }

    getFormasDePagamentoOuvinte(codigoOuvinte) {
        return http.get(`/api/formas-de-pagamento-ouvinte/${codigoOuvinte}`);
    }

    getSessionID() {
        return http.get('/api/pag-seguro/session-id');
    }

    onPagarComBoleto(cpf, dataNascimento, nome, endereco, bairro, cep, email, forma, codigoProjeto) {
        return http.post(
            '/api/pagar-com-boleto',
            {
                cpf, dataNascimento, nome, endereco, bairro, cep, email, forma, codigoProjeto,
            },
        );
    }

    onPagarComBoletoOuvinte(cpf, dataNascimento, nome, endereco, bairro, cep, email, forma, codigoOuvinte) {
        return http.post(
            '/api/pagar-com-boleto-ouvinte',
            {
                cpf, dataNascimento, nome, endereco, bairro, cep, email, forma, codigoOuvinte,
            },
        );
    }

    onPagarComCartao(cpf, dataNascimento, nome, email, forma, codigoProjeto, token, hash) {
        return http.post(
            '/api/pagar-com-cartao',
            {
                cpf, dataNascimento, nome, email, forma, codigoProjeto, token, hash,
            },
        );
    }

    onPagarComCartaoOuvinte(cpf, dataNascimento, nome, email, forma, codigoOuvinte, token, hash) {
        return http.post(
            '/api/pagar-com-cartao-ouvinte',
            {
                cpf, dataNascimento, nome, email, forma, codigoOuvinte, token, hash,
            },
        );
    }

    getTokenHash(numeroCartao, mesVencimento, anoVencimento, codigoSeguranca, sessionId) {
        return new Promise((resolve, reject) => {
            window.PagSeguroDirectPayment.setSessionId(sessionId);

            window.PagSeguroDirectPayment.getPaymentMethods({
                amount: 100,
                success: () => { },
                error: e => reject(e),
            });

            const cartao = numeroCartao.replace(/\s+/g, '');
            const cvv = codigoSeguranca;
            const mes = mesVencimento;
            const ano = anoVencimento;

            window.PagSeguroDirectPayment.getBrand({
                cardBin: cartao,
                success: (response) => {
                    // Bandeira do cartão encontrada.
                    const brandName = response.brand.name;
                    window.PagSeguroDirectPayment.createCardToken({
                        cardNumber: cartao,
                        brand: brandName,
                        cvv,
                        expirationMonth: mes,
                        expirationYear: ano,
                        success: (responseToken) => {
                            const { token } = responseToken.card;
                            const hash = window.PagSeguroDirectPayment.getSenderHash();
                            resolve({ Token: token, Hash: hash });
                        },
                        error: () => {
                            reject(new Error('Erro na criação do token.'));
                        },
                    });
                },
                error: () => {
                    reject(new Error('Bandeira não encontrada.'));
                },
            });
        });
    }
}

const apiService = new ApiService();
export default apiService;
